import { forwardRef } from 'react';

import { styled } from '@spazious/dollhouse-theme';

export type DataTablePaginationSelectorProps = {
  /**
   * Rows per page items
   */
  rowsPerPageItems: { label: string; value: number }[];
  /**
   * Handle change rows per page
   */
  handleChangeRowsPerPage: (event: any) => void;
  /**
   * Current rows per page
   */
  rowsPerPage: number;
  /**
   * Current rows
   */
  rows: number;
  /**
   * Total rows
   */
  totalRows: number;
  /**
   * Message to display. Use {rows} and {totalRows} to display the current rows and total rows.
   */
  message?: string;
};

export const DataTablePaginationSelector = styled(
  forwardRef<HTMLDivElement, DataTablePaginationSelectorProps>(
    (
      {
        rowsPerPage,
        totalRows,
        rowsPerPageItems,
        handleChangeRowsPerPage,
        rows,
        message = 'Showing {rows} of {totalRows} records',
        ...restProps
      },
      ref
    ) => {
      return (
        <div ref={ref} {...restProps}>
          <select
            name="data-table-pagination"
            value={rowsPerPage}
            onChange={handleChangeRowsPerPage}
          >
            {rowsPerPageItems.map(({ label, value }) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </select>

          <span>{message.replace('{rows}', `${rows}`).replace('{totalRows}', `${totalRows}`)}</span>
        </div>
      );
    }
  )
).withConfig({
  displayName: 'DataTablePaginationSelector',
})`
  display: flex;
  align-items: center;
  select {
    margin-right: 8px;
  }
  span {
    margin-right: 8px;
  }
`;
